import clsx from "clsx";
interface BaseButtonProp extends React.ButtonHTMLAttributes<HTMLButtonElement>{
  isTurnstile?: boolean;
  isInvaliadeAmount ?: boolean;
  title: string;
  type: 'button' | 'reset' | 'submit'; 
  children?: React.ReactNode;
  className?: string;
  validPhone?: boolean;
}

export const BaseButton = ({ 
  isInvaliadeAmount,
  isTurnstile, 
  title, 
  type, 
  className,
  children,
  validPhone,
  ...reset
}: BaseButtonProp) =>{

  return(
    <>
      <button
      {...reset}
        disabled={isTurnstile || isInvaliadeAmount ||validPhone}
        type={type || 'button'}
        className={clsx("flex uppercase justify-center rounded-[16px]  text-sm/6 font-semibold text-white shadow-sm bg-[#28386a] py-2 px-6 items-center hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600", className)}
          >
            {children}
            { title }
      </button>
    </>
  )
}